import { useEffect, useState } from 'react';

export default function DataDeletionPage() {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    document.title = 'Data Deletion - Golden Crown Hotels';
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // For now, we just show the confirmation. In production, this would send an email
    setSubmitted(true);
  };

  return (
    <div className="container py-5" style={{ maxWidth: '800px' }}>
      <h1 className="mb-4">Data Deletion Request</h1>
      <p className="text-muted mb-4">Last updated: February 18, 2026</p>

      <section className="mb-4">
        <h2>How to Delete Your Data</h2>
        <p>
          In accordance with data protection regulations, you have the right to request 
          deletion of your personal data from our systems. You can request deletion through 
          the following methods:
        </p>
      </section>

      <section className="mb-4">
        <h2>Option 1: Email Request</h2>
        <p>
          Send an email to <strong>privacy@goldencrown.co.il</strong> with the subject 
          line "Data Deletion Request" and include:
        </p>
        <ul>
          <li>Your full name</li>
          <li>Phone number used with our service</li>
          <li>Email address (if provided)</li>
          <li>Approximate dates of your hotel stay(s)</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>Option 2: Online Request Form</h2>
        {submitted ? (
          <div className="alert alert-success">
            <h4>Request Submitted</h4>
            <p className="mb-0">
              Your data deletion request has been received. We will process your request 
              within 30 days and send confirmation to the contact information provided.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="phone" className="form-label">Phone Number *</label>
              <input
                type="tel"
                className="form-control"
                id="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+1234567890"
                required
              />
              <div className="form-text">The phone number you used with our service</div>
            </div>

            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email Address</label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
              />
              <div className="form-text">Optional - for confirmation of deletion</div>
            </div>

            <div className="mb-3">
              <label htmlFor="message" className="form-label">Additional Information</label>
              <textarea
                className="form-control"
                id="message"
                rows={3}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Any additional details (e.g., dates of stay, hotel name)"
              />
            </div>

            <button type="submit" className="btn btn-primary">
              Submit Deletion Request
            </button>
          </form>
        )}
      </section>

      <section className="mb-4">
        <h2>What Data Will Be Deleted</h2>
        <p>Upon request, we will delete the following data associated with your account:</p>
        <ul>
          <li>Personal information (name, phone number, email)</li>
          <li>Service request history</li>
          <li>Order history</li>
          <li>Messages and communications</li>
          <li>Session data and preferences</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>Processing Time</h2>
        <p>
          We will process your data deletion request within <strong>30 days</strong> of receipt. 
          You will receive confirmation once your data has been deleted.
        </p>
      </section>

      <section className="mb-4">
        <h2>Data We May Retain</h2>
        <p>
          Certain data may be retained for legal or regulatory compliance purposes, including:
        </p>
        <ul>
          <li>Transaction records required for tax/accounting (retained per legal requirements)</li>
          <li>Data necessary for ongoing legal proceedings</li>
          <li>Anonymized/aggregated data that cannot identify you</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>WhatsApp Data</h2>
        <p>
          If you have communicated with us via WhatsApp, your data deletion request will also 
          include removal of message history from our systems. Note that messages already 
          delivered to your device will remain on your device unless you delete them manually.
        </p>
      </section>

      <section className="mb-4">
        <h2>Contact</h2>
        <p>
          For questions about data deletion, contact us at:<br />
          Email: privacy@goldencrown.co.il
        </p>
      </section>
    </div>
  );
}
